import React, {FC} from 'react';

import {useAppSelector} from '../../../../../../helpers/reduxHelpers';
import {ConversationModel} from '../../../../../../models/api/conversationModel';
import {TopicModel} from '../../../../../../models/api/topicModel';
import {getHasContextLinks} from '../../../../../../store/featureFlags/featureFlagsSelectors';
import {InboxesVisualConversationSelection} from '../../../../../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ViewerPanelId} from '../../../../../../store/panels/panelStateBase';
import {ConversationHeaderReferencePreviewerPillContainer} from './conversationHeaderReferencePreviewerPillContainer';
import {ConversationHeaderTopicPillContainer} from './conversationHeaderTopicPillContainer';

/*
 * Props.
 */

interface ConversationHeaderTopicContainerProps {
  panelId: ViewerPanelId;
  conversation?: ConversationModel;
  teammateId: number;
  conversationSelection: InboxesVisualConversationSelection;
  topic: TopicModel;
}

/*
 * Component.
 */

export const ConversationHeaderTopicContainer: FC<ConversationHeaderTopicContainerProps> = (props) => {
  const {panelId, conversation, teammateId, conversationSelection, topic} = props;

  const hasContextLinks = useAppSelector(getHasContextLinks);

  if (hasContextLinks) {
    return (
      <ConversationHeaderReferencePreviewerPillContainer
        panelId={panelId}
        conversation={conversation}
        teammateId={teammateId}
        conversationSelection={conversationSelection}
        topic={topic}
      />
    );
  }
  return (
    <ConversationHeaderTopicPillContainer
      key={topic.externalLink}
      conversationSelection={conversationSelection}
      topic={topic}
    />
  );
};
